import actions from './actions'
import limit from './metaData/limit'
export default {
  state: limit,
  actions
}
